var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"from-boti":false,"title":'תמונת החודש הראשונה שלך מוכנה!',"text":'אפשר לערוך את ההוצאות וההכנסות בלחיצה על כפתור העריכה ✏️',"notification-buttons":[
                  {
                    size:'normal',
                    title:'איך נבנתה תמונת החודש?',
                    subTitle: 'אפשר לקרוא כאן הסבר מפורט',
                    variant: 'primary',
                    action: _vm.openTour,
                  } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }